'use client';
import React, { useEffect } from 'react';
import { Button, Div } from '@pezeshk-book/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import { BlogsActions } from '@store/blogs/blogs-actions';

const Pagination = ({ typeId, current, last } : {typeId?: number, current: number, last: number}) => {
  const { currentPage, lastPage, loading } = useSelector((state: RootState) => state.blogs);
  const dispatch = useDispatch();

  const handleBlogPagination = () => {
    dispatch(BlogsActions.getExtendedBlogs({ typeId: typeId }));
  };

  useEffect(() => {
    dispatch(BlogsActions.setCurrentPage({ currentPage: current, lastPage: last }));
  }, []);

  if (currentPage !== lastPage) {
    return (
      <Div className={'justify-center my-20'}>
        <Button loading={loading} disabled={loading} onClick={handleBlogPagination}>
          مشاهده بیشتر
        </Button>
      </Div>
    );
  }

  return null;
};

export default Pagination;
